<!-- 批量补缴欠费 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody:{"paybackList":[{
                "parkCode": "PR3JTFRS",
                    "parkingCode": "210722092845900537855789",
                    "paybackTime": "20210803180058",
                    "paybackValue": 0.02,
                    "couponValue": 0.02,
                    "payOrigin": 2,
                    "payOriginRemark": "",
                    "paymentMode": 23,
                    "paymentModeRemark": "",
                    "thirdBillCode": "2021071613360720049876",
                    "collectName": "",
                },{
                    "parkCode":"2KNRNIJC",
                    "parkingCode":"2017111817223502036295",
                    "paybackTime":"20180411135558",
                    "paybackValue":2,
                    "couponValue":2,
                    "payOrigin":2,
                    "payOriginRemark":"",
                    "paymentMode":2,
                    "paymentModeRemark":"",
                    "thirdBillCode":"2021071613360720040909",
                    "collectName":"",
                    }]},
            responseCode: {
                    "data": {
                        "recordList": [
                            {
                                "parkingCode": "2017121215344302036759",
                                "ydtBillCode": "2021071613360720044319"
                            },
                            {
                                "parkingCode": "2017111817223502036295",
                                "ydtBillCode": "2021071613360732786768"
                            }
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },
            infoData: {
                explain: "第三方接入系统同步用户缴费信息到智慧停车开放平台",
                t_url: this.commonUrls.test + "paybackBatch",
                p_url: this.commonUrls.prod + "paybackBatch",
                precondition: "批量欠费补缴调用",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'paybackList', info2: '是', info3: 'List', info4: '欠费账单缴费列表' },
                        
                    ]
                },{
                    titleName: 'paybackList：欠费账单列表参数',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号（根据查费时返回的parkingCode回传）' },
                        { info1: 'paybackTime', info2: '是', info3: 'String', info4: '补缴时间，yyyyMMddHHmmss' },
                        { info1: 'paybackValue', info2: '是', info3: 'BigDecimal', info4: '补缴金额' },
                        { info1: 'couponValue', info2: '是', info3: 'BigDecimal', info4: '优惠金额' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源（<url>参考附录:/Api/appendixData#appendixData_1</url>）' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'Integer', info4: '支付方式（<url>参考附录:/Api/appendixData#appendixData_0</url>）' },
                        { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'collectorName', info2: '否', info3: 'String', info4: '收费员名称（vems车场可统一定义有意义的名称，便于财务人员对账）' },
                        { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方系统缴费订单号，每条账单唯一（缴费失败，再次缴费时，该账单号要与首次缴费的一致），用于重复同步时判断重复和对账（不超过32位）' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '补缴备注' },
                        { info1: 'receiveAccount', info2: '否', info3: 'String', info4: '到账商户号，32位' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'List', info4: '智慧停车账单编号' }
                    ]
                },{
                    titleName: 'recordList：具体对应parkingCode中，智慧停车请求payUrl的参数',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '请求paybackBatch的参数parkingCode' },
                        { info1: 'ydtBillCode', info2: '是', info3: 'String', info4: '智慧停车账单编号' },
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/paybackBatch.vue